module.exports = __webpack_public_path__ + "static/media/phoebe.7c6efb8a.png";